import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef, useState } from "react";
import classNames from "classnames";
import { ProfileDefaultIcon } from "@jti/brand-icons/profile-default";
import { isServerSide } from "@jti/fe-common";
import { LinkBehaviour } from "../../../../components/LinkBehaviour";
import { useOutsideClick } from "../../../../hooks/useOutsideClick";
import { Button } from "../Button";
import { ActionButton } from "../Tools/ActionButton/ActionButton";
import { UserDialog } from "./UserDialog";
import toolsStyles from "../Tools/Tools.module.scss";
import styles from "./UserActions.module.scss";
export const UserActions = ({ accountDropdownSettings, isLoggedIn, accountLink, accountLabel, userName, onLogOut, isEnabledUserIndication, }) => {
    const [isUserDialogOpen, setIsUserDialogOpen] = useState(false);
    const dialogRef = useRef(null);
    useOutsideClick(dialogRef, () => {
        setIsUserDialogOpen(false);
    });
    if (!isLoggedIn) {
        return (_jsx(Button, { asChild: true, children: _jsx(LinkBehaviour, { "aria-label": accountLabel, title: accountLabel, href: accountLink, className: toolsStyles.item, "data-testid": "headerLoginButton", children: _jsx(ProfileDefaultIcon, { className: toolsStyles.icon }) }) }));
    }
    const isAuthPage = !isServerSide() && window.location.pathname.includes("profile");
    return (_jsxs("div", { ref: dialogRef, className: classNames({ [styles.userButton]: isEnabledUserIndication }), children: [_jsx(ActionButton, { className: classNames({
                    [styles.userButtonLogged]: isEnabledUserIndication,
                    [styles.userButtonOpen]: isEnabledUserIndication && (isUserDialogOpen || isAuthPage),
                    [toolsStyles.item]: !isEnabledUserIndication,
                    [toolsStyles.itemOpen]: !isEnabledUserIndication && isUserDialogOpen,
                }), onClick: () => setIsUserDialogOpen((prevState) => !prevState), children: isEnabledUserIndication ? userName[0].toUpperCase() : _jsx(ProfileDefaultIcon, { className: toolsStyles.icon }) }), isUserDialogOpen && (_jsx(UserDialog, { setIsUserDialogOpen: setIsUserDialogOpen, accountDropdownSettings: accountDropdownSettings, userName: userName, onLogOut: onLogOut }))] }));
};
//# sourceMappingURL=UserActions.js.map